import { PROYECT, api_post, api_get } from "services/api"
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"
import { SET_UNITS_CONFIG_V2 } from "redux/reducers/units_v2/unitsReducer"

const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`

export const getUnitsSupport = (station = '') => {
  const url = `${process.env.REACT_APP_URL}/crm/units/conf?idStation=${station}`
  return async (dispatch) => {
    dispatch(startRequestComp('unitsSupportLoading'))
    await api_get(url).then(resp => {
      dispatch({
        type: SET_UNITS_CONFIG_V2,
        payload: resp
      })
    }).catch(err => {
      const error = err ? err : 'Error con el servicio'
      dispatch(setSnackbar(error,))
    })
    dispatch(stopRequestComp('unitsSupportLoading'))

  }
}

export const supportCancelApp = (idUnit = "", type = "", clean = null) => {
  const urlCancel = `${baseUrl}/tpv_notifications/${idUnit}/${type}/cancel_service`
  return async dispatch => {
    dispatch(startRequestComp('cancelAppLoading'))
    await api_post(urlCancel).then(res => {
      if (res.toLowerCase().includes('error')) {
        dispatch(setSnackbar(res.split(':')[0]))
        return
      }
      dispatch(setSnackbar(res.split(':')[0], 'success'))
      clean && clean()
    }).catch(err => {
      const error = err ? err : 'Error con el servicio'
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('cancelAppLoading'))
  }
}

export const supportPrintTicketApp = (idUnit = "", type = "", form = {}, clean = null) => {
  const urlPrint = `${baseUrl}/tpv_notifications/${idUnit}/${type}/reprint`
  return async dispatch => {
    dispatch(startRequestComp('printAppLoading'))
    await api_post(urlPrint, form).then(res => {
      if (res.toLowerCase().includes('error')) {
        dispatch(setSnackbar(res.split(':')[0]))
        return
      }
      dispatch(setSnackbar(res.split(':')[0], 'success'))
      clean && clean()
    }).catch(err => {
      const error = err ? err : 'Error con el servicio'
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('printAppLoading'))
  }
}